module.exports = __webpack_public_path__ + "img/bj37.1fd3d97d.png";